import { useEffect } from 'react';

interface MomentumToastProps {
  message: string;
  isVisible: boolean;
  onDismiss: () => void;
}

export default function MomentumToast({ message, isVisible, onDismiss }: MomentumToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onDismiss, 3500);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-40 animate-fade-in px-4 w-full max-w-sm">
      <div className="bg-black/80 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-2xl border border-[#40E0D0]/20">
        <p className="text-[14px] text-white text-center leading-relaxed">
          {message}
        </p>
      </div>
    </div>
  );
}
